import React, { useContext, useEffect, useState } from 'react'
import logo from 'images/Circle.gif'
import darklogo from 'images/dark logo.png'

import companyName from 'images/Shift.png'
import { handleSubmission, submission } from 'Auth'
import { BASE_URL } from 'BaseURL'
import { useNavigate, useParams } from 'react-router-dom'
import { themeContext } from 'contexts/theme_context/ThemeContext'

export default function NewPassword() {
    let { token, uid } = useParams()
    let [showed, setShowed] = useState(`password`)
    let [showed2, setShowed2] = useState('password')
    let navto = useNavigate()
    let [loading, setLoading] = useState(false)
    let { webtheme } = useContext(themeContext)
    let [user, setUser] = useState({})
    let [err, setErr] = useState({})
    useEffect(() => {
        let newUser = { ...user }
        newUser['token'] = token
        newUser['uid'] = uid
        setUser(newUser)
    }, [])
    let validation = (submission, e, obj, url, setErr, navto, router, setLoading) => {
        e.preventDefault()
        let warn = document.getElementById('re_new_passwordp')
        let cpass = document.getElementById('re_new_password').value
        let pass = document.getElementById('new_password').value
        warn.innerText = ''
        if (cpass == pass) {

            submission(e, obj, url, setErr, navto, router, setLoading)
        } else {
            warn.innerText = "Doesn't match password"

        }
    }
    const showPassword = (num) => {
        if (num == 1) {
            if (showed2 == 'password') {

                setShowed2('text')
            } else {
                setShowed2('password')
            }
        } else if (num == 0) {
            if (showed == 'password') {
                setShowed('text')
            } else {
                setShowed('password')
            }
        }

    }
    return (
        <div className='vh-100 d-flex justify-content-center align-items-center'>
            <div className={`${webtheme}-section-bg col-xl-3 col-lg-4 col-md-5 col-sm-6 col-xs-11 login-form rounded rounded-2 shadow shadow-sm`}>
                <div className={`d-flex align-items-center justify-content-center login-header-rounded ${webtheme}-header-bg py-3 w-100`}>

                    <img src={logo} className='h-100 col-1-5 me-2' alt="" />
                    {webtheme=='dark'?
                    <img src={companyName} className='h-100 col-xl-3 col-4  me-2' alt="" />:
                    <img src={darklogo} className='h-100 col-xl-3 col-4  me-2' alt="" />

                }

                </div>
                <div className='d-flex justify-content-center align-items-center flex-column pt-2 '>
                    <h1 className={`${webtheme}-text fs-5 fw-bold overflow-hidden`}>Set new password</h1>
                    <h2 className={`fs-8 ${webtheme}-grey overflow-hidden`}>Your idenity has been verified</h2>
                </div>

                <form action="" className='p-2' onSubmit={(e) => { validation(submission, e, user, BASE_URL + 'auth/users/reset_password_confirm/', setErr, navto, 'table/vehicles', setLoading) }}>
                    <div className='col-12 d-flex justify-content-center flex-wrap'>
                        <div className='col-11 position-relative d-flex align-items-center my-3'>
                            <input type={showed} name="new_password" id="new_password" className={`col-12 fs-7 ${webtheme}-text ${webtheme}-main-bg`} placeholder='New password' onChange={(e) => { handleSubmission(e.target, user, setUser) }} />
                            {showed == 'password' ?
                                <i className={`fa-solid fa-eye-slash ${webtheme}-grey col-2 fw-light position-absolute end-0 `} onClick={() => { showPassword(0) }}></i>
                                : <i className={`fa-solid fa-eye ${webtheme}-grey col-2 fw-light position-absolute end-0`} onClick={() => { showPassword(0) }}></i>}
                        </div>
                        <div className='col-11 position-relative d-flex align-items-center'>
                            <input type={showed2} name="re_new_password" id="re_new_password" className={`col-12 fs-7 ${webtheme}-text ${webtheme}-main-bg`} placeholder='Confirm new password' onChange={(e) => { handleSubmission(e.target, user, setUser) }} />
                            {showed2 == 'password' ? <i className="fa-solid fa-eye-slash light-grey col-2 fw-light position-absolute end-0" onClick={() => { showPassword(1) }}></i> : <i className="fa-solid fa-eye light-grey col-2 fw-light position-absolute end-0" onClick={() => { showPassword(1) }}></i>}
                        </div>
                        <div className='col-11 '>
                            <p className='text-danger fs-8 m-0' id='re_new_passwordp'></p>

                        </div>
                    </div>
                    <div className='d-flex justify-content-center pt-3 col-12'>
                        {/* <i className="fa-solid fa-spinner fa-spin"></i> */}
                        {loading ?
                            <button className='btn text-white btn-orange fs-7 py-2 col-11 text-nowrap text-center'><i className="fa-solid fa-spinner fa-spin"></i></button>

                            :
                            <button className='btn text-white btn-orange fs-7 py-2 col-11 text-nowrap text-center' id='addNewPassword'>Change password</button>
                        }
                    </div>
                    <div className='pt-3 d-flex justify-content-center'>
                        <p className={`opacity-50 fs-7 ${webtheme}-text`}>Back to <span className='text-primary cursor' onClick={() => { navto('/login') }}>login</span> </p>
                    </div>
                </form>
            </div>
        </div>
    )
}
